import { isLoaded } from '#src/app/shared/utils/async';

import type { PetitionDetailsPageHeadData } from './types';

export function petitionDetailsPageAlternateUrls({
	prefetchedData,
}: {
	prefetchedData: PetitionDetailsPageHeadData;
}): Record<string, string> | undefined {
	if (!isLoaded(prefetchedData.pageData)) {
		return undefined;
	}

	const { originalLocale, slug } = prefetchedData.pageData.pageData.petition;

	return { [originalLocale.localeCode]: `/p/${slug}` };
}
